import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InsidePages } from './components/InsidePages';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-cream" data-id="element-0" data-mp="2wifbn1k4umsw">
      <MetaPixel data-id="element-1" data-mp="28ufmg62gz4gf" />
      <CountdownBar data-id="element-2" data-mp="28tw9l3rof699" />
      <main data-id="element-3" data-mp="28t4mkhc5agul">
        <Hero data-id="element-4" data-mp="28suveqfd63nb" />
        <StatsBar data-id="element-5" data-mp="28sbbx5a2f776" />
        <Difference data-id="element-6" data-mp="23vchelmhoy8g" />
        <Recognize data-id="element-7" data-mp="23vupcfiil0w7" />
        <WhatsInside data-id="element-8" data-mp="23u9qidp62vsj" />
        <InsidePages data-id="element-9" data-mp="23v2rsz5cwt3a" />
        <Bonuses data-id="element-10" data-mp="23ti67z10skhk" />
        <Offer data-id="element-11" data-mp="3ik7e6ay3c1o0" />
        <Guarantee data-id="element-12" data-mp="3ikqy1x7ax04o" />
        <Testimonials data-id="element-13" data-mp="3ij65gd4jrr9g" />
        <Faq data-id="element-14" data-mp="3ihv2gfixenje" />
      </main>
      <Footer data-id="element-15" data-mp="3mlawd43m29se" />
    </div>;
}